module.exports = __webpack_public_path__ + "img/weight.4db6b3ce.svg";